/**
 * MODULE: _shared/frontend/lib/frontend/utils/brainInsightLinks.ts
 * PURPOSE: Deep links from brain insight entity refs to CRM and workspace surfaces.
 * PUBLIC_API: brainInsightEntityPath, brainInsightTypeLabel, brainLearnedPreferencesSettingsPath
 * AGENT_SAFETY: SAFE
 * FILE_SIZE: 82 / 150 lines
 * RECENT: 2026-05-25 [2.2.1207] — Settings deep link for learned preference management.
 */

const INSIGHT_TYPE_LABELS: Record<string, string> = {
  at_risk: 'At risk',
  deal_stalled: 'Deal stalled',
  churn_risk: 'Churn risk',
  high_intent: 'High intent',
  page_engagement: 'Page engagement',
  account_page_notes: 'Account notes',
  sequence_replied: 'Sequence reply',
  sequence_bounced: 'Sequence bounced',
  sms_received: 'SMS reply',
  sms_delivered: 'SMS delivered',
  sms_failed: 'SMS failed',
  email_opened: 'Email opened',
  email_clicked: 'Email clicked',
};

export function brainInsightEntityPath(
  entityType?: string,
  entityId?: string,
): string | null {
  const type = (entityType || '').trim().toLowerCase();
  const id = (entityId || '').trim();
  if (!id) return null;
  if (type === 'deal' || type === 'opportunity') {
    return `/crm/deals/${encodeURIComponent(id)}`;
  }
  if (type === 'contact') {
    return `/crm/contacts?contactId=${encodeURIComponent(id)}`;
  }
  if (type === 'account' || type === 'company') {
    return `/crm/accounts?accountId=${encodeURIComponent(id)}`;
  }
  return null;
}

export function brainInsightTypeLabel(insightType?: string): string {
  const key = (insightType || '').trim().toLowerCase();
  if (key && INSIGHT_TYPE_LABELS[key]) {
    return INSIGHT_TYPE_LABELS[key];
  }
  return (insightType || 'insight').replace(/_/g, ' ');
}

/** Profile tab anchor for the Learned preferences Settings card [2.2.1206]. */
export function brainLearnedPreferencesSettingsPath(): string {
  return '/settings?tab=profile#brain-learned-preferences';
}
